module.exports = __webpack_public_path__ + "media/images/flags/4x3/smr-9ca0007a83b778fb34db462ed1d00acc.svg";